/**
 * `/team/approvals` route — gated on `requests:approve:team` per be-063.
 * Renders the live <TeamApprovalsScreen> list view (Phase 08.2, D-16).
 */
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { TeamApprovalsScreen } from "../features/team/TeamApprovalsScreen.js";

export const Route = createFileRoute("/_auth/team/approvals")({
  staticData: { breadcrumb: { labelKey: "team:nav.approvals" } },
  beforeLoad: requirePermission({
    anyOf: ["requests:approve:team"],
    defaultRoute: "/me/overview",
  }),
  component: TeamApprovalsScreen,
});
